import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../utils/auth";
import "./LoginPage.css";
import loginImg from "../assests/Login.png";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [focusedField, setFocusedField] = useState("");
  const [emailValid, setEmailValid] = useState(null);
  const [passwordValid, setPasswordValid] = useState(null);
  const [shake, setShake] = useState(false);

  const navigate = useNavigate();

  // Real-time email validation
  useEffect(() => {
    if (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setEmailValid(emailRegex.test(email));
    } else {
      setEmailValid(null);
    }
  }, [email]);

  // Real-time password validation
  useEffect(() => {
    if (password) {
      setPasswordValid(password.length >= 6);
    } else {
      setPasswordValid(null);
    }
  }, [password]);

  // // Password strength calculation
  // const getPasswordStrength = (pwd) => {
  //   if (pwd.length === 0) return "";
  //   if (pwd.length < 6) return "weak";
  //   if (pwd.length < 10) return "medium";
  //   return "strong";
  // };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setShake(false);

    // Validate before submitting
    if (!emailValid || !passwordValid) {
      setError("Please enter valid email and password");
      setShake(true);
      setTimeout(() => setShake(false), 500);
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password })
        }
      );

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Login failed");
        setLoading(false);
        setShake(true);
        setTimeout(() => setShake(false), 500);
        return;
      }

      // Success state
      setSuccess(true);

      // ✅ save auth details immediately
      login(data.token, data.role, data.userId, email);

      // ⏳ wait for 2 seconds before redirect (keep loader on during this time)
      setTimeout(() => {
        navigate("/");
        window.location.reload();
      }, 2000);

    } catch (err) {
      setError("Server not reachable");
      setLoading(false);
      setShake(true);
      setTimeout(() => setShake(false), 500);
    }
  };

  const handleFieldFocus = (fieldName) => {
    setFocusedField(fieldName);
  };

  const handleFieldBlur = () => {
    setFocusedField("");
  };

  return (
    <div className="login-page">
      {/* Floating Shapes */}
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <div className="login-left">
        <img src={loginImg} alt="Login" />
      </div>

      <div className="login-right">
        <div className={`login-card ${success ? 'success' : ''} ${shake ? 'shake' : ''}`}>
          <div className="welcome-header">
            <h2>Welcome Back</h2>
            <div className="animated-underline"></div>
          </div>
          <p className="subtitle">Please sign in to continue</p>
          <form onSubmit={handleSubmit}>
            <div className={`field ${focusedField === 'email' ? 'focused' : ''}`}>
              <label className="field-label">
                Email Address
              </label>
              <div className="input-wrapper">
                <input
                  type="email"
                  placeholder="student@test.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onFocus={() => handleFieldFocus('email')}
                  onBlur={handleFieldBlur}
                  className={emailValid === true ? 'valid' : emailValid === false ? 'invalid' : ''}
                  required
                />
                {email && (
                  <span className={`field-status ${emailValid ? 'valid' : 'invalid'}`}>
                    {emailValid ? '✓' : '✗'}
                  </span>
                )}
              </div>
            </div>

            <div className={`field ${focusedField === 'password' ? 'focused' : ''}`}>
              <label className="field-label">
                Password
              </label>
              <div className="password-wrapper">
                <input
                  type={showPwd ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onFocus={() => handleFieldFocus('password')}
                  onBlur={handleFieldBlur}
                  className={passwordValid === true ? 'valid' : passwordValid === false ? 'invalid' : ''}
                  required
                />
                <button
                  type="button"
                  className={`toggle ${showPwd ? 'visible' : ''}`}
                  onClick={() => setShowPwd(!showPwd)}
                  tabIndex="-1"
                >
                  {showPwd ? 'HIDE' : 'SHOW'}
                </button>
                {/* {password && (
                  <span className={`field-status ${passwordValid ? 'valid' : 'invalid'}`}>
                    {passwordValid ? '✓' : '✗'}
                  </span>
                )} */}
              </div>
              {/* {password && (
                <div className="password-strength">
                  <div className={`strength-bar ${getPasswordStrength(password)}`}></div>
                  <span className="strength-text">
                    {getPasswordStrength(password) === 'weak' && 'Weak'}
                    {getPasswordStrength(password) === 'medium' && 'Medium'}
                    {getPasswordStrength(password) === 'strong' && 'Strong'}
                  </span>
                </div>
              )} */}
            </div>

            {/* <div className="form-options">
              <label className="checkbox-container">
                <input type="checkbox" />
                <span className="checkmark"></span>
                Remember me
              </label>
            </div> */}

            {error && (
              <div className="error-message">
                <span className="error-icon">!</span>
                {error}
              </div>
            )}

            {success && (
              <div className="success-message">
                <span className="success-icon">✓</span>
                Login successful! Redirecting...
              </div>
            )}

            <button
              className={`button1 ${loading ? 'loading' : ''} ${success ? 'success' : ''}`}
              disabled={loading || success}
              type="submit"
            >
              {loading ? (
                <div className="btn-loader">
                  <div className="code-loader">
                    <span className="code-bracket">&lt;</span>
                    <span className="code-dot code-dot-1"></span>
                    <span className="code-dot code-dot-2"></span>
                    <span className="code-dot code-dot-3"></span>
                    <span className="code-bracket">/&gt;</span>
                  </div>
                  <span>Authenticating...</span>
                </div>
              ) : success ? (
                <div className="success-content">
                  <span className="success-icon">✓</span>
                  <span>Success!</span>
                </div>
              ) : (
                <div className="login-content">
                  <span>Sign In</span>
                </div>
              )}
            </button>
          </form>

          <div className="login-footer">
            <p>
              Need assistance? <span className="contact-admin">Contact Administrator</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
} 
